export type PurchaseLineTemplateState = {
  systemId: string;
  lineEditable: boolean;
  portalTemplateCode: string;
};

function normalizeTemplateCode(value: string | null | undefined): string {
  return (value ?? "").trim();
}

export function getChangedPurchaseLineTemplates<T extends PurchaseLineTemplateState>(
  rows: T[],
  savedRows: T[]
): T[] {
  const savedTemplateCodes = new Map(
    savedRows.map((row) => [row.systemId, normalizeTemplateCode(row.portalTemplateCode)] as const)
  );

  return rows.filter(
    (row) =>
      row.lineEditable &&
      savedTemplateCodes.get(row.systemId) !== normalizeTemplateCode(row.portalTemplateCode)
  );
}

export function hasTemplateAssignmentChange<T extends PurchaseLineTemplateState>(
  changedRows: T[],
  savedRows: T[]
): boolean {
  const savedTemplateCodes = new Map(
    savedRows.map((row) => [row.systemId, normalizeTemplateCode(row.portalTemplateCode)] as const)
  );

  return changedRows.some((row) => {
    const previousTemplateCode = savedTemplateCodes.get(row.systemId) ?? "";
    const nextTemplateCode = normalizeTemplateCode(row.portalTemplateCode);

    return nextTemplateCode.length > 0 && nextTemplateCode !== previousTemplateCode;
  });
}
